/**
 * `expo-constants` no browser. O app só lê `Constants.expoConfig?.version` (fallback da
 * versão no AuthContext); o resto existe para o código que porventura consultar.
 */
import { applicationId, nativeApplicationVersion, nativeBuildVersion } from "./application";
import { deviceName as nomeDoAparelho } from "./device";

export enum ExecutionEnvironment {
  Bare = "bare",
  Standalone = "standalone",
  StoreClient = "storeClient",
}

export enum AppOwnership {
  Expo = "expo",
}

export type ExpoConfigWeb = {
  name: string;
  slug: string;
  version: string;
  scheme: string;
  extra: Record<string, unknown>;
  android: { package: string; versionCode: number };
  ios: { bundleIdentifier: string; buildNumber: string };
  web: { bundler: string };
};

const env = import.meta.env as Record<string, string | undefined>;

const versao = nativeApplicationVersion ?? "0.0.0";
const build = nativeBuildVersion ?? "0";

const expoConfig: ExpoConfigWeb = {
  name: "Tirvu+",
  slug: "tirvumais",
  version: versao,
  scheme: "tirvumais",
  extra: {
    eas: { projectId: "tirvumais" },
    ambiente: env.MODE ?? "production",
  },
  android: { package: "com.dntec.tirvumais", versionCode: Number(build) || 0 },
  ios: { bundleIdentifier: "com.dntecnologia.tirvu", buildNumber: build },
  web: { bundler: "vite" },
};

const Constants = {
  expoConfig,
  /** Alias antigo (SDK < 46). */
  manifest: expoConfig,
  manifest2: null,
  appOwnership: null as AppOwnership | null,
  executionEnvironment: ExecutionEnvironment.Standalone,
  deviceName: nomeDoAparelho ?? undefined,
  isDevice: true,
  sessionId: (() => {
    try {
      return crypto.randomUUID();
    } catch {
      return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
  })(),
  statusBarHeight: 0,
  systemFonts: [] as string[],
  platform: { web: { ua: typeof navigator !== "undefined" ? navigator.userAgent : "" } },
  nativeAppVersion: versao,
  nativeBuildVersion: build,
  applicationId,
  get debugMode(): boolean {
    return Boolean(import.meta.env.DEV);
  },
  async getWebViewUserAgentAsync(): Promise<string | null> {
    return typeof navigator !== "undefined" ? navigator.userAgent : null;
  },
};

export default Constants;
